import React from "react";
import { Breath, Career, Footer, NavTech, Social } from "../components";

const Job = () => {
  return (
    <>
      <Career />
      <Breath />
      <Footer />
    </>
  );
};

export default Job;
